import RaindropInput from "../raindrop-input/raindrop-input.tsx";

import ModelComponent from "../model-component/model-component.tsx";

const ModelComponentPaymentMethod = ({
  paymentMethodId,
  createdAt,
  paymentMethodIdentifierStripe = null,
  paymentMethodIdentifierGoCardless = null,
}) => {
  return (
    <ModelComponent
      modelId={paymentMethodId}
      colorBorderAccent="dark:border-color-dark-model-payment-method border-color-model-payment-method"
    >
      <RaindropInput
        label={"Created At"}
        value={createdAt}
        onChange={() => {}}
        icon={null}
        isEditing={false}
        isShowLabel={true}
      />

      <RaindropInput
        label={"Stripe Payment Method ID"}
        value={paymentMethodIdentifierStripe}
        onChange={() => {}}
        icon={null}
        isEditing={false}
        isShowLabel={true}
      />

      <RaindropInput
        label={"GoCardless Payment Method ID"}
        value={paymentMethodIdentifierGoCardless}
        onChange={() => {}}
        icon={null}
        isEditing={false}
        isShowLabel={true}
      />
    </ModelComponent>
  );
};

export default ModelComponentPaymentMethod;
